import { render, staticRenderFns } from "./OtherSetting.vue?vue&type=template&id=5e83df67&scoped=true"
import script from "./OtherSetting.vue?vue&type=script&lang=js"
export * from "./OtherSetting.vue?vue&type=script&lang=js"
import style0 from "./OtherSetting.vue?vue&type=style&index=0&id=5e83df67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83df67",
  null
  
)

export default component.exports